// @ts-strict-ignore
import {
	DiProcess,
	logTemplates,
	TemplateRegistry,
	templateService,
	utils,
} from '@wikia/ad-engine';
import { Injectable } from '@wikia/dependency-injection';
import { merge } from 'rxjs';
import {
	registerBfaaTemplate,
	registerFloorAdhesionTemplate,
	registerStickyTlbTemplate,
} from '../../shared';
import { registerRoadblockTemplate } from '../../shared/templates/roadblock-template';
import { registerUapDomElements } from './configs/register-uap-dom-elements';

@Injectable()
export class GamespotTemplatesSetup implements DiProcess {
	constructor(private registry: TemplateRegistry) {
		templateService.setInitializer(this.registry);
	}

	execute(): void {
		const bfaa$ = registerBfaaTemplate(this.registry, registerUapDomElements);
		const floorAdhesion$ = registerFloorAdhesionTemplate(this.registry);
		const stickyTlb$ = registerStickyTlbTemplate(this.registry, registerUapDomElements);

		const isMobile = utils.client.isSmartphone() || utils.client.isTablet();
		const roadblock$ = registerRoadblockTemplate(
			this.registry,
			isMobile
				? [
						'video',
						'floor_adhesion',
						'mpu_top',
						'mpu_plus_top',
						'mpu_middle',
						'overlay_mpu_top',
						'mpu-top-inc',
						'mpu-bottom-inc',
						'mobile-incontent-all',
						'mobile-incontent-ad-plus-inc',
						'mobile-banner-plus',
						'mobile-incontent-plus-bottom',
						'mobile-incontent-plus',
						'mobile-logo',
						'mobile-flex-inc',
						'mobile-incontent-ad-inc',
						'mobile-mpu',
						'mobile-banner',
						'incontent-mobile-flex',
						'mobile-highimpact-plus',
						'mobile-autoplay-plus',
						'mobile-flex-bottom',
						'mobile-native-plus-top',
						'mobile-mpu-bottom',
						'mobile-banner-bottom',
						'mobile-incontent-ad',
						'mobile-native',
						'native-top',
						'logo_top',
					]
				: [
						'mpu_top',
						'mpu_plus_top',
						'mpu_middle',
						'mpu_bottom',
						'leader_plus_top',
						'leader_top',
						'leader_bottom',
						'overlay_leader_top',
						'overlay_mpu_top',
						'leader_middle',
						'sky-leader-plus-top',
						'incontent-ad',
						'incontent-ad-inc',
						'leader-plus-inc',
						'mpu-top-inc',
						'mpu-bottom-inc',
						'leader-bottom-inc',
						'logo_top',
						'native-top',
						'leader-ad-plus-top',
						'leader-ad-plus-middle',
						'native-mpu',
						'incontent-ad-plus-billboard-bottom',
						'incontent-ad-plus-inc',
						'incontent-all-top',
						'incontent-narrow-all-top',
						'video',
					],
		);

		logTemplates(merge(bfaa$, floorAdhesion$, roadblock$, stickyTlb$));
	}
}
